import { fetch, service } from "@szgc/plt-core-v2";

const api = {
  get prefix() {
    return service.cloudBase;
  }
};

/**
 * 针对主数据源列表请求的结果管理
 */
class PltSourceManager {
  private state: any = {};
  async getDataSource(dataConfigId: string, linkedParams: any, params?: any) {
    if (!this.state[dataConfigId]) {
      let dataSet;
      try {
        const { success, data } = await fetch.post(
          api.prefix + `/api/appproc/main-data/read/${dataConfigId.split("-")[0]}/data/read`,
          {
            data: {
              dataType: "multi",
              params
            }
          }
        );
        if (success) {
          dataSet = data;
        } else {
          dataSet = [];
        }
      } catch (error) {
        console.log(error);
        dataSet = [];
      } finally {
        this.state[dataConfigId] = dataSet;
      }
    }

    let result: any[] = this.state[dataConfigId];

    if (linkedParams) {
      for (const x in linkedParams) {
        result = result.filter((d) => d[x] === linkedParams[x].value);
      }
    }

    return result;
  }

  async getDataDict(params: { limiter: string; [p: string]: any }) {
    const type = JSON.parse(params.limiter).value;
    if (!this.state[type]) {
      this.state[type] = await fetch.post(api.prefix + `/api/appproc/prime/select`, {
        data: params
      });
    }

    return this.state[type];
  }
}

export default new PltSourceManager();

